import styled from 'styled-components';
import PlainButton from '../PlainButton';
import media from '../../styles/media';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  padding-bottom: 30px;
  margin-bottom: 30px;
  ${media.desktop`
    flex-direction: row;
  `}
`;

export const Button = styled(PlainButton)`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  max-width: 255px;
  ${media.desktop`
    margin-left: 20px;
    margin-top: 0;
  `}
`;
